import { SET_TOKEN } from "../actionTypes";

export const setJWTtoken = (token, expiresAt) => ({
  type: SET_TOKEN,
  token,
  expiresAt
});
